import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
    static targets = ["submit", "checkbox"];

    connect() {
        this.checkboxTargets.forEach((checkbox) => {
            checkbox.addEventListener("change", () => {
                this.validate();
            });
        });
        this.validate();
    }

    validate() {
        if (this.checkboxTargets.some((checkbox) => checkbox.checked)) {
            this.submitTarget.disabled = false;
        }
    }
}
